import React, { useCallback, useState } from 'react';
import axios from '../redux/sagas/axios';
import { CountriesPrefsSelector } from './countries_prefs_selector';

const Edit = ({ preferences, initialMyPreferences, isApp, isTutorial, countriesPrefs, currentPrefId }) => {
  const [isSelectedIds, setIsSelectedIds] = useState(
    initialMyPreferences.map((p) => p.id)
  );
  const [myPreferences, setMyPreferences] = useState(initialMyPreferences);

  const onChangePreferenceIds = useCallback(
    (preference) => {
      let newIsSelectedIds = isSelectedIds;

      if (isSelectedIds.includes(preference.id)) {
        newIsSelectedIds = isSelectedIds.filter((id) => id !== preference.id);
        setIsSelectedIds(newIsSelectedIds);
        setMyPreferences(myPreferences.filter((p) => p.id !== preference.id));
      } else {
        const newMyPreferences =
          preference.preference_type !== 1
            ? myPreferences.filter(
                (p) => p.preference_type !== preference.preference_type
              )
            : myPreferences;

        newIsSelectedIds = newMyPreferences
          .map((p) => p.id)
          .concat(preference.id);

        setIsSelectedIds(newIsSelectedIds);
        setMyPreferences(newMyPreferences.concat(preference));
      }

      try {
        const preferenceIds = JSON.stringify({
          preference_ids: newIsSelectedIds,
        });
        axios.post('/api/preferences_users', preferenceIds);
      } catch (e) {
        alert('通信に失敗しました。');
      }
    },
    [myPreferences, isSelectedIds]
  );

  let tmp_preference_type = 0;

  return (
    <div>
      {isApp && isTutorial && (
        <CountriesPrefsSelector countriesPrefs={countriesPrefs} currentPrefId={currentPrefId} />
      )}
      <div className="container col-md-8 col-lg-6 mb-5">
        {preferences.map((preference, index) => {
          const isSelected = isSelectedIds.includes(preference.id);

          if (tmp_preference_type === preference.preference_type) {
            tmp_preference_type = preference.preference_type;
            return (
              <label
                key={index}
                className={`p-2 m-2 text-fz-12px cursor-pointer badge badge-pill ${
                  isSelected
                    ? 'text-white bg-tunagate-gradation'
                    : 'badge-light'
                }`}
              >
                <input
                  type={preference.preference_type != 1 ? 'radio' : 'checkbox'}
                  checked={isSelected}
                  onChange={() => onChangePreferenceIds(preference)}
                  style={{ display: 'none' }}
                />
                {preference.name}
              </label>
            );
          } else {
            tmp_preference_type = preference.preference_type;
            return (
              <span key={index}>
                <h6 className="text-fz-16px text-fw-bold text-left mt-5 pb-2">
                  {preference.description}
                </h6>
                <label
                  className={`p-2 m-2 text-fz-12px cursor-pointer badge badge-pill ${
                    isSelected
                      ? 'text-white bg-tunagate-gradation'
                      : 'badge-light'
                  }`}
                >
                  <input
                    type={
                      preference.preference_type != 1 ? 'radio' : 'checkbox'
                    }
                    checked={isSelected}
                    onChange={() => onChangePreferenceIds(preference)}
                    style={{ display: 'none' }}
                  />
                  {preference.name}
                </label>
              </span>
            );
          }
        })}
      </div>
    </div>
  );
};

export default Edit;
